import React, { useEffect } from 'react';
import Container from '@mui/material/Container';
import Header from '../../common/Header/Header';
import Footer from '../../common/Footer/Footer';
import scrollToTop from '../../../functions/scrollToTop';
import './NotFound.css';

const NotFound = () => {
  // Set the document title
  document.title = `Page not found | InsightCoin`;

  // Scroll to the top of the page when the component mounts
  useEffect(() => {
    scrollToTop();
  }, []);

  // JSX structure for the NotFound component
  return (
    <>
      {/* Header component */}
      <Header />
      <br />
      <Container maxWidth="lg">
        {/* Main content with the "404" message */}
        <div className="not-found41">
          <p>404, Page not found!</p>
        </div>
      </Container>
      <br />
      {/* Footer component */}
      <Footer />
    </>
  );
}

export default NotFound;
